<template>
    <CContainer fluid>
        <h1 class="mb-4 fw-200">Crear usuario</h1>
        <CCard class="p-4">
            <CForm @submit.prevent="submit" ref="user_form" key="refresh">

                <CRow>
                    <CCol sm="12" lg="4">
                        <CInput 
                        label="Usuario" 
                        placeholder="Usuario"
                        v-model="user.username"
                        name="username"
                        ref="username"
                        v-bind.sync="errors.username"
                        @input='clearThisError("username")'
                        />
                    </CCol>
                    <CCol sm="12" lg="4">
                        <CInput 
                        label="Nombre" 
                        placeholder="Nombre"
                        v-model="user.first_name"
                        name="first_name"
                        ref="first_name"
                        v-bind.sync="errors.first_name"
                        @input='clearThisError("first_name")'
                        />
                    </CCol>
                    <CCol sm="12" lg="4">
                        <CInput 
                        label="Apellido" 
                        placeholder="Apellido"
                        v-model="user.last_name"
                        name="last_name"
                        ref="last_name"
                        v-bind.sync="errors.last_name"
                        @input='clearThisError("last_name")'
                        />
                    </CCol>
                </CRow>

                <CRow>
                    <CCol sm="12" lg="4">
                        <CInput 
                        label="Email" 
                        placeholder="Email"
                    
                        v-model="user.email"
                        name="email"
                        ref="email"
                        v-bind.sync="errors.email"
                        @input='clearThisError("email")'
                        />
                    </CCol>
    
                    <CCol sm="12" lg="4">
                        <CInput 
                        label="Contraseña" 
                        placeholder="Contraseña"
                        type="password"
                        v-model="user.password"
                        name="password"
                        ref="password"
                        v-bind.sync="errors.password"
                        @input='clearThisError("password")'
                        />
                    </CCol>

                    <CCol sm="12" lg="4">
                        <CInput 
                        label="Confirmar contraseña" 
                        placeholder="Contraseña"
                        type="password"
                        name="password_confirmation"
                        ref="password_confirmation"
                        v-bind.sync="errors.password_confirmation"
                        v-model="user.confirm_password"
                        @input='clearThisError("password_confirmation")'
                        />
                    </CCol>
    
                </CRow>

                <CRow>

                    <CCol sm="12" lg="4">
                        <CSelect 
                        label="Perfil de Usuario" 
                        :options="roles"
                        placeholder="Elige un perfil"
                        :value.sync="user.role_id"
                        name="role_id"
                        ref="role_id"
                        v-bind.sync="errors.role_id"
                        @input='clearThisError("role_id")'
                        />
                    </CCol>

                    <CCol sm="12" lg="4">
                        <CSelect 
                        label="Sector" 
                        placeholder="Elige un sector"
                        :options="departments"
                        :value.sync="user.department_id"
                        name="department_id"
                        ref="department_id"
                        v-bind.sync="errors.department_id"
                        @input='clearThisError("department_id")'
                        />
                    </CCol>
    
                    <CCol sm="12" lg="4">
                        <CInput 
                        label="Teléfono" 
                        placeholder="Teléfono"
                        type="phone"
                        v-model="user.phone"
                        name="phone"
                        ref="phone"
                        v-bind.sync="errors.phone"
                        @input='clearThisError("phone")'
                        />
                    </CCol>
                </CRow>

                <CRow>
                    <CInput
                    type="hidden"
                    ref="hidden"
                    v-bind.sync="errors.hidden"
                    v-model="user.hidden"
                    />
                </CRow>

                <CRow>
                    <CCol class="d-flex">
                        <div class="ml-auto">

                            <CButton
                            class="mr-2"
                            shape="pill"   
                            color="success"
                            type="submit"
                            :disabled='loading'
                          
                            >
                                {{loading ? "Procesando" : "Crear"}}
                            </CButton>

                            <CButton
                            class=""
                            shape="pill"   
                            color="danger"
                            type="reset"
                            @click="clearForm()"
                            >
                            <div class="d-flex align-items-center">
                                <CIcon name="cil-trash" class="mr-1"/>
                                Borrar
                            </div>
                            </CButton>

                        </div>
                    </CCol>
                </CRow>
            </CForm>
        </CCard>
    </CContainer>
</template>

<script>
import axios from "axios";

/**
 *  TODO: 
 *  Cuando mostrar resultado de las validaciones en loa campos
 */

export default {
    data(){
        return{
            
            roles: [],
            departments:[],
            user:{
                hidden: undefined
            },
            externalData: undefined,
            errors: {},
            refresh: 0,
            loading: false
        }
    },
    methods:{
        submit(){
            let me = this;
            me.loading = true;
            let form = new FormData(this.$refs.user_form);
            me.errors = {};

            me.$api.users.store(form)
            .then(response => {
                me.loading = false;
                this.$swal.fire({
                    titleText: "¡Excelente!",
                    text: response.message ?? "Creado exitosamente",
                    icon: "success"
                });
                
                me.clearForm();

                this.$router.push('/usuarios');
            })
            .catch(error => {
                // console.log(error.response);
                me.loading = false;
                if(error.response.status = 422){
                    me.setErrorMessages(error.response.data.errors);
                } else {
                    this.$swal.fire({
                    titleText: "Algo salió mal",
                    text: error.response.message ?? "Error al crear",
                    icon: "error"
                });
                }
            });    
        },
        getErrors(key){
            return this.errors[key];
        },
        getExternalData(){
            let me = this;
            let request_1 = me.$api.users.roles();
            let request_2 = me.$api.users.departments();
            axios.all([request_1, request_2])
            .then(axios.spread((response_1, response_2) => {
                me.roles = [];
                me.roles = response_1.data.roles.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                });

                me.departments = [];
                me.departments = response_2.data.departments.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                });
            }))
            .catch(error => {
                console.log(error.response);
            });
        },

        setErrorMessages(errors){
            console.log('ponemos errores')
            let me = this;
            
            for (const item in errors) {
                me.errors[item] = {
                    invalidFeedback: errors[item].reduce((acc, cur) => acc + "\n" + cur),
                    isValid: false
                };
            }

            me.$refs["hidden"].$emit('input',(Math.random()*1e32).toString(36), new InputEvent(""));
        },

        clearForm(){
            let form = this.$refs.user_form;
            form.reset();
            this.errors = {};
            this.user = {};
        },
        clearThisError(value){
            this.errors[value] = {};
        }
    },
    watch:{
        errors(newVal, lastval){
            return newVal;
        }
    },
    created(){
        this.getExternalData();
    },
   
    
}
</script>

<style>
    .fw-200{
        font-weight: 200;
    }
</style>